import React, {createContext, useContext, useEffect, useReducer, useState} from 'react';
import {Button, Checkbox, DatePicker, message, Modal, Select, Switch} from 'antd';
import "./index.less";
import {doAuditAction, quickClassifydetail} from "../../api";
import {useHistory, useParams} from 'react-router-dom';
import CaseCard from '../../component/CaseCard'

const { Option } = Select;
const { RangePicker } = DatePicker;
const Ctx = createContext();
const initInfo = {
    headTitle: '',
    classifyList: [],
    styleList: [],
    propertyList: [],
    isEditor: false,
    styleId: null,
    propertyId: null,
    caseClassifyDTOList: {},
    designMaster: null,
    id: null
}
const reducer = (state, action) => {
    return { ...state, ...action };
}

//  子组件模态框
const EditModal = () => {
    const { state: { isModalVisible, info }, dispatch } = useContext(Ctx);
    const [caseInfo, setCaseInfo] = useState();//详情内容数据
    const [caseImgList, setCaseImgList] = useState([]);//详情案例数据
    useEffect(() => {
        if (isModalVisible) {
            setCaseImgList([])
            if (info) {
                quickClassifydetail(info).then(res => {
                    console.log(res)
                    if (res?.error?.errorCode == '0') {
                        setCaseInfo(res?.data?.caseInfo)
                        setCaseImgList(res?.data?.contents)
                    }
                })
            }
        }
    }, [info, isModalVisible])

    //  退出弹出
    const handleCancel = () => {
        dispatch({ isModalVisible: false });
    };
    return (
        <div>
            <Modal width='1500px' visible={isModalVisible} footer={false} wrapClassName='classify_modal' onCancel={handleCancel} title={info.headTitle}>
                <div className='content'>
                    <h2>{caseInfo?.titleOrigin}</h2>
                    <div className='imgCnt'>
                        {
                            caseImgList?.length > 0 ? (
                                caseImgList.map(item => {
                                    return (
                                        <img src={item?.imgUrl+"?x-oss-process=image/resize,p_50"} alt="" />
                                    )
                                })
                            ) : ''
                        }
                    </div>

                </div>
            </Modal>


        </div>
    )
}
// 父组件 最外层
function ClassifyManage() {
    const [classifyName, setClassifyName] = useState('');// 分类词名称
    const [isAuditNum, setIsAuditNum] = useState(0);//已审核数量
    const [noAuditNum, setNoAuditNum] = useState(0);//未审核数量
    const [proportion, setProportion] = useState(0);//已审核占比
    const [caseList, setCaseList] = useState([]);//案例列表
    const [caseDownLoadValue, setCaseDownLoadValue] = useState([]);
    const [caseLevelValue, setCaseLevelValue ] = useState([]);
    const [checkedValue, setCheckedValue] = useState([]);
    const [isAuditList, setIsAuditList] = useState([]);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(60)
    const [state, dispatch] = useReducer(reducer, {
        isModalVisible: false, info: initInfo, success: false
    });
    const { classifyId } = useParams()
    let history = useHistory()

    useEffect(() => {
        if (caseList.length > 0) {
            let arr = []
            caseList.forEach(item => {
                arr.push(item.caseId)
            })
            setIsAuditList(arr)
        }
    }, [caseList])
    useEffect(() => {
        // 获取一级分类数据以及风格，擅长领域数据
        getCaseList(1, null, null, null, null)
    }, [])
    useEffect(() => {
        if (state.success) {
            // getDataList(page);
            dispatch({ success: false })
        }
    }, [state.success]);
    // 获取案例列表 渲染表格
    const getCaseList = (page, delAuditList, isAuditList, downList, levelList,) => {
        let params = {
            classifyId: classifyId,
            delAuditList: delAuditList,//已勾选删除的列表
            isAuditList: isAuditList,//剩余未勾选的列表
            downList: downList,
            levelList: levelList,
            page: page,
            pageSize: pageSize,

        }
        doAuditAction(params).then((res) => {
            if (res?.error?.errorCode == 0) {
                setClassifyName(res?.data?.classifyName)
                setIsAuditNum(res?.data?.isAuditNum)
                setNoAuditNum(Number(res?.data?.totalCaseNum) - Number(res?.data?.isAuditNum))
                setProportion(res?.data?.proportion)
                if (res?.data?.pageDTO?.contents.length > 0) {
                    setCaseDownLoadValue([])
                    setCaseList([])
                    setCaseList(res?.data?.pageDTO?.contents)
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    if (delAuditList && delAuditList.length > 0) {
                        setCheckedValue([])
                    }
                } else {
                    setCaseList([])
                    // message.error('暂无数据')
                }
            }
        }).finally(() => {
        })

    }
    //  返回上一页
    const backPage = () => {
        history.go(-1)
    }

    useEffect(() => {
        console.log(checkedValue)

    }, [checkedValue])

    const onChange = (value) => {
        if (value.length > 60) {
            message.info('最多选择60个选项');
            return;
        } else {
            setCheckedValue(value);
        }

    };
    const onCaseLevelChange = (value, caseId) => {
        for (let i = 0; i < caseLevelValue.length; i++) {
            if (caseId == caseLevelValue[i].caseId) {
                caseLevelValue.splice(i, 1);
            }
        }
        let caseLevel = {caseId: caseId, caseLevel: value};
        caseLevelValue.push(caseLevel)
    }
    const onCaseIdCopy = () => {
        document.execCommand("copy")
    }
    const onCaseDownLoadChange = (value, caseId) => {
        for (let i = 0; i < caseDownLoadValue.length; i++) {
            if (caseId == caseDownLoadValue[i]) {
                caseDownLoadValue.splice(i, 1);
            }
        }
        if (value == true) {
            caseDownLoadValue.push(caseId)
        }
    }
    // 删除
    const deleteCase = () => {
        if (checkedValue.length > 0) {
            nextCaseData()
        } else {
            message.info('请选择需要删除的案例')
        }
    }

    // 下一批数据
    const nextCaseData = () => {
        let arr = [...isAuditList]
        let levelList = [{
            level: 3,
            caseIdList: []
        }, {
            level: 4,
            caseIdList: []
        }, {
            level: 5,
            caseIdList: []
        }, {
            level: 6,
            caseIdList: []
        }
        ];
        if (checkedValue.length > 0) {
            for (let i = 0; i < checkedValue.length; i++) {
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j] == checkedValue[i]) {
                        arr.splice(j, 1);
                        j--;
                    }
                }
            }
            for (let m = 0; m < caseLevelValue.length; m++) {
                levelList[caseLevelValue[m].caseLevel - 3].caseIdList.push(caseLevelValue[m].caseId)
            }
            getCaseList(1, checkedValue, arr, caseDownLoadValue, levelList)
        }else{
            for (let m = 0; m < caseLevelValue.length; m++) {
                levelList[caseLevelValue[m].caseLevel - 3].caseIdList.push(caseLevelValue[m].caseId)
            }
            getCaseList(1, [], arr, caseDownLoadValue, levelList)
        }
    }

    return (
        <div className="classifyManage">
            <div className="topForm">
                <h2>
                    快速分类审核
                    <Button style={{ float: 'right' }} type="primary" onClick={backPage}>返回</Button>
                </h2>

            </div>
            <div className="classifyName">
                分类名称：<strong>{classifyName}</strong>
            </div >
            <div className="middleContent">
                <span>
                    已审核数量: <strong>{isAuditNum}</strong>
                </span>
                <span>
                    未审核数量: <strong>{noAuditNum}</strong>
                </span>
                <span>
                    已审核占比: <strong>{proportion}</strong>
                </span>
            </div>
            <div className='magazineCaseCnt'>
                <div className='magazineDetailList'>
                    <Checkbox.Group
                        onChange={onChange}
                        value={checkedValue}
                        className='checkBoxContainer'
                    >
                        {
                            caseList.map((v, i) => (
                                <Checkbox
                                    key={i}
                                    value={v.caseId}
                                    className={`${'checkBoxItem'} ${checkedValue.includes(v.caseId) ? 'checkBoxItemActive' : ''
                                        }`}
                                >
                                    <CaseCard
                                        key={v.caseId}
                                        data={v}
                                    />
                                    <select className='caseLevel' mode='tags'
                                            defaultValue={v.caseLevel}
                                            onChange={event => onCaseLevelChange(event.target.value,v.caseId)}
                                    >
                                        <option value="" label="无">
                                            无
                                        </option>
                                        <option value="6" label="6级">
                                            6级
                                        </option>
                                        <option value="5" label="5级">
                                            5级
                                        </option>
                                        <option value="4" label="4级">
                                            4级
                                        </option>
                                        <option value="3" label="3级">
                                            3级
                                        </option>
                                    </select>
                                    <span className='caseIdInfo' onClick={onCaseIdCopy}>{v.caseId}</span>
                                    <Switch className='caseDownload' checkedChildren="下架" unCheckedChildren="不下架" onChange={event => onCaseDownLoadChange(event.valueOf(),v.caseId)}
                                        //defaultChecked={caseDownLoadValue.includes(v.caseId) ? true : false}/>
                                            defaultChecked={false}/>
                                    <div className='clickModal' onClick={(e) => {
                                        e.preventDefault()
                                        dispatch({ isModalVisible: true, info: v.caseId });//关闭弹窗刷新列表
                                    }}>

                                    </div>
                                </Checkbox>
                            ))
                        }
                    </Checkbox.Group>
                    {/* {caseList?.length > 0
                        ? caseList.map((item) => (
                            <CaseCard
                                key={item.caseId}
                                data={item}
                            />
                        )
                        )
                        : null} */}
                </div>
                {
                    caseList.length > 0 ? (
                        <div className='bottomButton'>
                            <Button key="submit" type="primary" onClick={() => deleteCase()}>
                                删除
                            </Button>
                            <Button key="submit" type="primary" disabled={checkedValue.length > 0 ? true : false} onClick={() => nextCaseData()}>
                                下一批
                            </Button>
                        </div>
                    ) : ''
                }

            </div>
            <Ctx.Provider value={{ state, dispatch }} >
                <EditModal isModalVisible={state.isModalVisible} />
            </Ctx.Provider>


        </div >
    )
}

export default ClassifyManage;
